/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useContext } from "react";

import { useTranslation } from "react-i18next";

import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

import { colors, DeleteOutlineIcon } from "@dotnet/telematics-design-system";

import FileIcon from "../../../assets/customIcons/FileIcon";
import DropzoneContext from "../../../context/dropzone/dropzoneContext";
import { FILE_UPLOAD_STATUS } from "../../../shared";
import Button from "../../Button/Button";
import Tooltip from "../../Tooltip/Tooltip";
import { UploadedFileMultipleProps } from "../types";
import StatusIcon from "./StatusIcon";
import { useStyles } from "./styles";

const UploadedFileMultiple = ({
  name,
  id,
  isLoading,
  fileUploadStatus,
  failedUpload,
  ...props
}: UploadedFileMultipleProps) => {
  const { removeFile } = useContext(DropzoneContext);

  const { t } = useTranslation();

  const {
    mainDivCSS,
    statusCSS,
    fileIconCSS,
    uploadStatusCSS,
    loaderCSS,
    failedUploadCSS
  } = useStyles();

  return (
    <div {...props} css={css(mainDivCSS)}>
      <div css={css(statusCSS)}>
        <div>
          <FileIcon css={css(fileIconCSS)} />

          <Typography
            variant="body2Medium"
            sx={{
              color: colors.gray700,
              wordBreak: "break-word"
            }}
          >
            {name}
          </Typography>
        </div>
        <div css={css(uploadStatusCSS)}>
          {isLoading && (
            <div css={css(loaderCSS)}>
              <CircularProgress size={20} />
            </div>
          )}

          {fileUploadStatus === FILE_UPLOAD_STATUS.Ready ? (
            <Tooltip
              placement="top"
              title={t("Button##delete")}
              disableTouchListener
            >
              <Button
                color="primarySubtle"
                size="small"
                variant="iconOnly"
                icon={<DeleteOutlineIcon />}
                disabled={isLoading}
                onClick={() => removeFile(id)}
              />
            </Tooltip>
          ) : (
            <StatusIcon uploadStatus={fileUploadStatus!} />
          )}
        </div>
      </div>

      {failedUpload !== null && (
        <div css={css(failedUploadCSS)}>{failedUpload}</div>
      )}
    </div>
  );
};

export default UploadedFileMultiple;
